import React from 'react'

import { NavLink } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'

import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const PetsNavLinks = (props) => {
	const { selectedFacility, location, client, roles } = props
	const isGroomer = roles.length === 1 && roles.includes('Groomer')
	const classes = useStyles()

	return (
		<div className={classes.crumbInt}>
			<NavLink
				className={classes.crumb}
				to={isGroomer ? `/facilities/${selectedFacility ? selectedFacility._id : null}/groomingHome` : `/facilities/${selectedFacility ? selectedFacility._id : null}/schedule`}>
				Home /
			</NavLink>

			<NavLink className={classes.crumb} to={`/clients`}>
				Clients /
			</NavLink>

			<NavLink className={clsx([classes.crumb])} to={`/clients/${client ? client._id : null}/appointments`}>
				{client ? client.account.full_name : 'No Name'} /
			</NavLink>

			<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
				Pets
			</NavLink>
		</div>
	)
}

export default PetsNavLinks
